@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.container {
    max-width: 100%;
    width: 100%;
    background: var(--white);    
    box-shadow: 0px 2px 6px var(--gray-03);
    overflow:auto;
    padding: 12px 10px 10px;
    border: none;
    border: 1px solid var(--gray-07);
    @include breakpoints.desktop { 
        border-radius: 0px 0px 20px 20px;   
    }
}

.title {
    font-family: typography.$font-mont;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 16px;
    color: var(--brand-indigo);
    line-height: 22.4px;
    letter-spacing: 0.32px;
    vertical-align: middle;

}

.list {
    color: var(--blue-01);
    font-size: 14px;
    font-family: typography.$font-mont;
    font-weight: 400;
    font-style: normal;
    line-height: 22.4px;
    letter-spacing: 0.32px;
    vertical-align: middle;
    @include breakpoints.desktop {
        line-height: 150%;
        letter-spacing: 0px;
    }
}

.listTrophy {
    color: var(--blue-01);
    font-size: 14px;
    font-family: typography.$font-mont;
    font-weight: 400;
    font-style: normal;
    line-height: 22.4px;
    letter-spacing: 0.32px;
    vertical-align: middle;
    margin-left: 25px;
    @include breakpoints.desktop {
        line-height: 150%;
        letter-spacing: 0px;
        margin-left: 0px;
    }
}

.icon {
    padding-right: 5px;
    background-color: var(--white);
}

.iconTrophy {
    display: none;
    @include breakpoints.desktop {
        display: inline-block;
    }
}


.noIcon {
    padding-left: 29px;
}
